import { render, staticRenderFns } from "./orderDetailsComponent.vue?vue&type=template&id=cbffe726&"
import script from "./orderDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./orderDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports